import React, { useEffect, useState } from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import Dialog, { DialogProps } from "@mui/material/Dialog";
//import closeIcon from "../../assets/icon-xout-black.svg";
import closeIcon from "../../assets/icon-close.svg";
import DialogContent from "@mui/material/DialogContent";
import { BannerNotificationContent, HomePageContent } from "../contents";

type Props = {
  isOpen: boolean;
  close: () => void;
};

const ReferalDialog = ({ isOpen, close }: Props) => {
  const homeScreenContent: any = HomePageContent();
  const bannerNotificationContent : any = BannerNotificationContent();
  const isProd = process.env.REACT_APP_ENV === "production";
  const referalDialog =  homeScreenContent?.entry?.referalDialogBlock?.referalDialog;
  const [scroll, setScroll] = React.useState<DialogProps["scroll"]>("body");

  useEffect(() => {
    handleClickOpen("body");
  }, []);

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setScroll(scrollType);
  };
  return (
    <Dialog
      open={isOpen}
       onClose={(event,reason: any) => {
			  if(reason === 'backdropClick'){
			  return;
			} close()}}

      aria-modal="true"
      aria-labelledby="scroll-dialog-title"
      // aria-describedby="scroll-dialog-description"
      scroll={scroll}
      sx={{
        border: "1px solid #000",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        "& .MuiDialog-paper": {
          borderRadius: "20px",
        },
      }}
      className="referalDialog"
    >
      <Box>
      </Box>
      <Box className="modalMain">
        <Typography component="h2" id="scroll-dialog-title" className="modalTitle">
          {referalDialog?.title}
        </Typography>
        <Typography className="modaldescP">
         {referalDialog?.desc1}
        </Typography>
        <Typography component={"p"} className="descSpacing modaldescP" >
          {referalDialog?.desc2}
        </Typography>
        <Typography component={"p"} className="descSpacing modaldescP" >
          {referalDialog?.desc3}
        </Typography>
        <Typography component={"p"} className="descSpacing modaldescP">
         {referalDialog?.desc4}
        </Typography>
      </Box>
      <Box sx={{ pl: {xs : 2, sm : "40px"}, mb: 6 }}>
        <Button
          sx={{
            textTransform: "none",
          }}
          onClick={close}
          variant="contained"
          color="primary"
        >
          {referalDialog?.continue_btn}
        </Button>
      </Box>
      <Stack
          direction="row"
          justifyContent="end"
          className="close-icon-cantainer"
          sx={{ p: 1, mt: 2 }}
        >
          <Typography component="button" onClick={close} aria-label="Close the dialog" className="buttonModel p-0">
          <img
            src={closeIcon}
            alt="Close the dialog"
            className="cursor-pointer"
          />
          </Typography>
        </Stack>
    </Dialog>
  );
};

export default ReferalDialog;
